import styleInject from 'style-inject';

var css_248z = ".TrendValue-module_bullTrend__1GKDl{color:var(--color-success)}.TrendValue-module_bearTrend__wPJwK{color:var(--color-error)}";
var styles = {"bullTrend":"TrendValue-module_bullTrend__1GKDl","bearTrend":"TrendValue-module_bearTrend__wPJwK"};
styleInject(css_248z);

export { styles as default };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiVHJlbmRWYWx1ZS5tb2R1bGUuc2Nzcy5qcyIsInNvdXJjZXMiOltdLCJzb3VyY2VzQ29udGVudCI6W10sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OyJ9
